/* unplugin-vue-components disabled */import { render } from "./phoneDemo.vue?vue&type=template&id=00c3a2de&scoped=true&ts=true"
import script from "./phoneDemo.vue?vue&type=script&lang=ts"
export * from "./phoneDemo.vue?vue&type=script&lang=ts"

import "./phoneDemo.vue?vue&type=style&index=0&id=00c3a2de&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c3a2de"]])

export default __exports__